import { assertNever } from "@@/shared/assert-never";
import type { OrderPayRequestFulfilledEvent } from "@@/shared/orders/order-events/events/order-pay-request-events/order-pay-request-fulfilled.event";
import type { OrderPaymentFulfilledEvent } from "@@/shared/orders/order-events/events/order-payment-events/order-payment-fulfilled.event";
import type { OrderPaymentRefundFulfilledEvent } from "@@/shared/orders/order-events/events/order-payment-events/order-payment-refund-fulfilled.event";
import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import type { SettlementPaymentType } from "./settlements/payment.settlement";

const parsePaymentType = (
    event:
        | OrderPayRequestFulfilledEvent
        | OrderPaymentFulfilledEvent
        | OrderPaymentRefundFulfilledEvent,
): SettlementPaymentType => {
    switch (event.paymentProvider) {
        case "PAY_REQUEST":
            throw new Error(
                `A settlement fulfilled event cannot have a payment provider of type PAY_REQUEST; ${event._id}`,
            );
        case "GIFTCARD":
            return "GIFT_CARD";
        default:
            return event.paymentProvider;
    }
};

const parsePaymentTypeName = (
    event:
        | OrderPayRequestFulfilledEvent
        | OrderPaymentFulfilledEvent
        | OrderPaymentRefundFulfilledEvent,
): Translatable => {
    switch (event.paymentProvider) {
        case "PAY_REQUEST":
            throw new Error(
                `A settlement fulfilled event cannot have a payment provider of type PAY_REQUEST; ${event._id}`,
            );
        case "GIFTCARD":
            return translation({
                sv: "Presentkort",
                en: "Gift card",
            });
        case "FREE":
            return translation({
                sv: "Gratis",
                en: "Free",
            });
        case "ON_PREMISE":
            return translation({
                sv: "Betalad på plats",
                en: "Paid on premise",
            });
        case "STRIPE":
            return translation({
                sv: "Stripe",
                en: "Stripe",
            });
        case "SWISH":
            return translation({
                sv: "Swish",
                en: "Swish",
            });
        default:
            assertNever(event, "Unhandled payment provider", {
                valueProp: "paymentProvider",
            });
    }
};

export { parsePaymentType, parsePaymentTypeName };
